"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.or = exports.and = exports.jsonIsEqual = exports.boolean = void 0;
function boolean(isTrue) {
    return isTrue;
}
exports.boolean = boolean;
function jsonIsEqual({ list = [] }) {
    const jsonArray = list.map((v) => typeof v === 'string' ? v : JSON.stringify(v));
    return jsonArray.every((v) => v === jsonArray[0]);
}
exports.jsonIsEqual = jsonIsEqual;
function and({ list = [] }) {
    const arrayToCheck = Array.isArray(list[0]) ? [...list[0]] : [...list];
    let result = list[0];
    for (let i = 1; i < arrayToCheck.length && result; i++) {
        result && (result = arrayToCheck[i]);
    }
    return result;
}
exports.and = and;
function or({ list = [] }) {
    const arrayToCheck = Array.isArray(list[0]) ? [...list[0]] : [...list];
    let result = list[0];
    for (let i = 1; i < arrayToCheck.length && !result; i++) {
        result || (result = arrayToCheck[i]);
    }
    return result;
}
exports.or = or;
